import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="drag-and-drop"
export default class extends Controller {
	static targets = ["sortIdField"]

	connect() {}

	// ######################################################
	// Hier kommt irgendwann unser eigenes Drag-and-Drop hin
	// ######################################################

	// Schreibt die SortID in die Hidden-Fields
	updateSortId() {
		let counter = 1
		this.sortIdFieldTargets.forEach((hiddenField) => {
			hiddenField.value = counter
			counter += 1
		})
	}
}
